'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const isFunction = require('../_chunk/isFunction-aCEz9d.js');
const isTypedArray = require('../_chunk/isTypedArray-BBEkFl.js');

function isBoolean(x) {
    return typeof x === 'boolean';
}

function isSymbol(value) {
    return typeof value === 'symbol';
}

function isString(value) {
    return typeof value === 'string';
}

exports.isEqual = isFunction.isEqual;
exports.isFunction = isFunction.isFunction;
exports.isLength = isFunction.isLength;
exports.isNil = isFunction.isNil;
exports.isNotNil = isFunction.isNotNil;
exports.isNull = isFunction.isNull;
exports.isUndefined = isFunction.isUndefined;
exports.isPlainObject = isTypedArray.isPlainObject;
exports.isPrimitive = isTypedArray.isPrimitive;
exports.isTypedArray = isTypedArray.isTypedArray;
exports.isBoolean = isBoolean;
exports.isString = isString;
exports.isSymbol = isSymbol;
